var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFinish = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 22,
  viewBox: "0 -2 20 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.25 2.75H5.5V0h2.75zM13.75 0H11v2.75h2.75zM5.5 13.75h2.75V11H5.5zm13.75-5.5V5.5H16.5v2.75zm0 5.5V11H16.5v2.75zm-8.25 0h2.75V11H11zM19.25 0H16.5v2.75h2.75zM11 5.5V2.75H8.25V5.5zM2.75 8.25V5.5H5.5V2.75H2.75V0H0v22h2.75V11H5.5V8.25zm11 2.75h2.75V8.25h-2.75zm-5.5-2.75V11H11V8.25zM5.5 5.5v2.75h2.75V5.5zM11 8.25h2.75V5.5H11zm2.75-5.5V5.5h2.75V2.75z"
})));
export { SvgFinish as ReactComponent };
export default __webpack_public_path__ + "48241b75ade6d606588481ed6384b299.svg";